/**
 * idscript.externalLinks
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.1
 * @author  Imhof Digital <info@imhof-digital.de>
 * @property  HTMLCollection            Collection of all a-tags
 * @method    init()                    Initiates externalLinks object
 * @method    checkLinks()              Checks for external links
 * @method    bindClickHandler( link )  Bind a click hanlder to a link
 * @method    optIn( event )            Shows an opt-in and waits for a user-action
 * @method    adjustOverlay()           Adjusts the overlay on the users screen to the center
 */
idscript.externalLinks = {
  /**
   * pageLinks
   *
   * HTMLCollection of all a-tags
   *
   * @since   5.6.1
   * @usedby  this.checkLinks()
   */
  pageLinks: document.getElementsByTagName( 'a' ),

  /**
   * adjustOverlay()
   *
   * Adjusts the overlay on the users screen to the center
   *
   * @since 5.6.1
   * @usedby  this.optIn( event )
   * @return  void
   */
  adjustOverlay: function() {
    // using strict mode
    'use strict';
    var overlayContainer = document.getElementsByClassName( 'overlay container' );
    overlayContainer[ 0 ].style.top = window.pageYOffset+'px';
    return;
  },

  /**
   * optIn( event )
   *
   * Shows an opt-in and waits for a user-action
   *
   * @since 5.6.1
   * @usedby  method  this.bindClickHandler( link )
   * @uses    method  this.adjustOverlay()
   * @return  void
   */
  optIn: function( event ) {
    // using strict mode
    'use strict';

    //cross-browser capture of event-Object
    event = ( event ) ? event : window.event;
    event.preventDefault();

    var href = '';
    var hostname = '';
    if( !event.srcElement.href || event.srcElement.href === '' && event.srcElement.parentElement === 'a' ) {
      href = event.srcElement.parentElement.href;
      hostname = event.srcElement.parentElement.hostname;
    } else {
      href = event.srcElement.href;
      hostname = event.srcElement.hostname;
    }

    //overlay content
    var content = '';
    content  = '<div class="overlay container">';
    content += '<div class="overlay content">';
    content += '<p>Sie verlassen jetzt unsere Webseite und werden zu</p>';
    content += '<p>'+hostname+'</p>';
    content += '<p>weitergeleitet.</p>';
    content += '<div class="overlay buttons">';
    content += '<div class="overlay button ok"><p>Ok</p></div>';
    content += '<div class="overlay button annulation"><p>Abbruch</p></div>';
    content += '</div>';
    content += '</div><!-- END CONTENT --></div><!-- END CONTAINER -->';

    //append overlay
    var bodyElement = document.getElementsByTagName( 'body' );
    bodyElement[ 0 ].insertAdjacentHTML( 'afterend', content );
    var overlayContainer = document.getElementsByClassName( 'overlay container' );

    // freeze page
    var htmlElement = document.getElementsByTagName( 'html' );
    htmlElement[ 0 ].style.overflow = 'hidden';

    //adjust overlay
    idscript.externalLinks.adjustOverlay();
    window.addEventListener( 'resize', idscript.externalLinks.adjustOverlay );

    // handle click on ok
    var okButton = document.getElementsByClassName( 'overlay button ok' );
    okButton[ 0 ].addEventListener( 'click', function() {
      htmlElement[ 0 ].style.overflow = 'auto';
      overlayContainer[ 0 ].remove();
      window.open( href );
      return;
    } );

    // handle click on annulation
    var annulationButton = document.getElementsByClassName( 'overlay button annulation' );
    annulationButton[ 0 ].addEventListener( 'click', function() {
      htmlElement[ 0 ].style.overflow = 'auto';
      overlayContainer[ 0 ].remove();
      return;
    } );

    return;
  },

  /**
   * bindClickHandler( link )
   *
   * Binds a click handler to a link
   *
   * @since   5.6.1
   * @usedby  this.checkLinks()
   * @uses    this.optIn()
   * @return  void
   */
  bindClickHandler: function( link ) {
    link.addEventListener( 'click', this.optIn );
    return;
  },

  /**
   * checkLinks()
   *
   * Check for external links and bind a click handler
   *
   * @since   5.6.1
   * @uses    property  this.pageLinks
   * @uses    method    this.bindCLickHandler( object )
   * @return  void
   */
  checkLinks: function() {
    // using strict mode
    'use strict';
    // iterate over HTMLCollection
    for (var i = 0; i < this.pageLinks.length; i++) {
      // check for external links
      if( this.pageLinks[ i ].hostname !== location.hostname ) {
        // bind the click handler
        this.bindClickHandler( this.pageLinks[ i ] );
      }
    }
    return;
  },

  /**
   * init()
   *
   * Initiates the externalLinks object
   *
   * @since   5.6.1
   * @uses    method  this.checkLinks()
   * @return  void
   */
  init: function() {

    this.checkLinks();

    return;
  }
};
idscript.externalLinks.init();
